import { Button, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { PlanPackageAiProposalWorkflow } from "src/generated/graphqlTypes";
import { useNavigateToRpav } from "src/hooks/useNavigateToRpav";
import { useRouteParams } from "src/hooks/useRouteParams";
import {
  ConstructionDocumentPicker,
  useConstructionDocumentPicker,
} from "src/routes/libraries/plan-package-v2/components/ConstructionDocumentPicker";
import { useCreatePlanPackageAiProposalMutation } from "src/routes/libraries/plan-package-v2/components/overview/PlanPackageDocumentImportPanel.generated";
import { PlanPackageDetailsParams } from "src/routes/routesDef";

/**
 * Picks the construction document Blueprint AI imports plan data from: one of the plan's Plan documents, or a new
 * upload. Open it with `aiMode` so the header picks up the Blueprint AI logo and gradient title.
 */
export function ImportFromDocumentModal() {
  const { planPackageId, planPackageVersionId } = useRouteParams<PlanPackageDetailsParams>();
  const { closeModal } = useModal();
  const navigateToRpav = useNavigateToRpav();
  const [createProposal] = useCreatePlanPackageAiProposalMutation();
  const picker = useConstructionDocumentPicker(async (asset) => {
    const { data } = await createProposal({
      variables: {
        input: { planPackageId, asset, workflow: PlanPackageAiProposalWorkflow.ConstructionDocumentExtraction },
      },
    });
    // Uploading onto a published version forks a draft to hold the new document, and the proposal only shows on the
    // latest version, so follow it there; the new variables fetch it
    const draftId = data?.createPlanPackageAiProposal.planPackage.aggregateDraft?.id;
    if (draftId && draftId !== planPackageVersionId) navigateToRpav(draftId);
    closeModal();
  });

  return (
    <>
      <ModalHeader>Import From Document</ModalHeader>
      <ModalBody>
        <ConstructionDocumentPicker picker={picker} />
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="text" onClick={closeModal} />
        <Button
          label="Import"
          variant="ai"
          disabled={picker.missing || (picker.submitting && "Importing...")}
          onClick={picker.submit}
        />
      </ModalFooter>
    </>
  );
}
